// src/api/axios.js
import axios from 'axios';
//const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
//  baseURL: 'https://sttc_test_api.skillablers.com/api', // Adjust your backend base URL here
const instance = axios.create({
 
 baseURL: 'https://techtrustconclaveapi.skillablers.com/api',
});

// Add JWT token to every request if exists
// instance.interceptors.request.use(
//   config => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   error => Promise.reject(error)
// );

export default instance;
